type SupportedLocale = "vi" | "en";

const weekdayMap: Record<SupportedLocale, string[]> = {
  vi: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], // ví dụ
};

export function getWeekdayLabel(
  day: number,
  month: number,
  year: number,
  locale: SupportedLocale = "vi"
) {
  const date = new Date(year, month - 1, day); // month - 1 vì JS: 0–11
  const dow = date.getDay(); // 0 = CN, 1 = T2, ...

  const labels = weekdayMap[locale] ?? weekdayMap.vi;
  return labels[dow];
}

export const getDateInfo = (dateStr: string, locale: SupportedLocale = "vi") => {
  // Tự parse cho chắc, tránh lệch múi giờ
  const [year, month, day] = dateStr.split("-").map(Number);

  const weekday = getWeekdayLabel(day, month, year, locale); // 0=CN, 1=T2...

  const formattedDate = `${String(day).padStart(2, "0")}/${String(
    month
  ).padStart(2, "0")}`;

  return { weekday, formattedDate };
};

export const toIsoDateFromYMD = (year: number, month: number, day: number) => {
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
    2,
    "0"
  )}`;
};
